$ = require 'jquery'
Dialog = require 'views/lib/dialog'
Keys = require 'data/keys'
PluginModalView = require 'views/plugin/plugin-modal-view'
PopOver = require 'views/lib/pop-over'
SidebarState = require 'view-models/sidebar-state'
UserInput = require 'views/internal/user-input'

module.exports = PluginModal = new class

  @modalView = null

  shortcut: (key) ->
    switch key
      when Keys.Escape
        @close()
        ["Esc - Hide Plugin Modal", "Plugin Modal"]

  isOpen: -> @modalView?

  update: (content) ->
    if !@modalView?
      console?.warn('Warning: No modal open')
      return
    else if content.idPlugin != @modalView.content.idPlugin
      console?.warn('Can not update modal you did not open')
      return

    @modalView.update(content)

  open: (args) ->
    { model, content } = args

    PopOver.hide()
    SidebarState.hideUnpinnedSidebar()
    if Dialog.isVisible
      Dialog.hide(true)

    @close()

    @modalView = new PluginModalView({ model, content, fxClose: @close.bind(@) })

    $('.pop-over').before(@modalView.render().el)

    # events
    @modalView.$el.click (e) ->
      if !$(e.target).closest('.plugin-chrome-wrapper').length && !$('.pop-over.is-shown').length
        # clicked outside the modal and no popovers open -> close the modal
        PluginModal.close()
      return

    UserInput.addHandler(@, {
      scope: 'plugin_modal'
      modal: true
    })
    return

  close: ->
    if @isOpen()
      UserInput.removeHandler(@)
      @modalView.close()
      @modalView = null
    return



// WEBPACK FOOTER //
// ./app/scripts/views/lib/plugin-modal.coffee